<!-- New component created to display a table of internal Atlas jobs -->
<template>
  <div id="job-queue">
    <template v-if="!jobQueueLoadingState">
      <div class="toolbar-wrapper">
        <h4>Job Queue</h4>
      </div>
    
      <div class="inner-quality__content">
        <JobQueueTable />
      </div>
    </template>
    <content-spinner
      v-else
      :show="jobQueueLoadingState"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import JobQueueTable from './components/JobQueueTable.vue';
import ContentSpinner from '@/core/components/ContentSpinner.vue';

const {
  mapState: jobQueueMapState,
  mapActions: jobQueueMapActions,
} = createNamespacedHelpers('monitoring');

export default {
  name: 'JobQueue',
  components: {
    JobQueueTable,
    ContentSpinner,
  },
  computed: {
    ...jobQueueMapState({
      jobQueueLoadingState: state => state.jobQueue.isLoading,
    }),
  },
  methods: {
    ...jobQueueMapActions(['setJobQueueLoading']),
  },
  mounted() {
    this.setJobQueueLoading();
  },
};
</script>

<style scoped lang="scss">
#job-queue {
  height: 100vh;
  display: grid;
  row-gap: 10px;
  grid-template-rows: auto 1fr;
}

.toolbar-wrapper {
  display: flex;
  align-items: center;
}

.toolbar-wrapper {
  background-color: #fff;
  padding: 10px 20px;
  border-bottom: 1px solid #ddd;
  justify-content: space-between;
}

.inner-quality__content {
  padding: 0 1.5rem 1.5rem;
  display: grid;
}

</style>